var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSw1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.3202 10.6685C36.3035 11.3585 35.7318 11.9052 35.0418 11.8902C34.3518 11.8735 33.8052 11.3018 33.8202 10.6118L33.8885 7.60184L30.8802 7.5335C30.1902 7.51684 29.6435 6.94517 29.6585 6.25517C29.6752 5.56517 30.2468 5.0185 30.9368 5.0335L35.1968 5.13184C35.8868 5.14684 36.4335 5.7185 36.4168 6.4085L36.3202 10.6685Z",
    fill: "#696977"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71183 15.5767V35.8117C9.71183 36.975 8.77016 37.9167 7.60683 37.9167H4.1885C3.02516 37.9167 2.0835 36.975 2.0835 35.8117V15.5767C2.0835 14.415 3.02516 13.4717 4.1885 13.4717H7.60683C8.77016 13.4717 9.71183 14.415 9.71183 15.5767Z",
    fill: "#696977"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5151 25.8335V35.8118C28.5151 36.3702 28.2934 36.9052 27.8984 37.3002C27.5034 37.6952 26.9684 37.9168 26.4101 37.9168H22.9917C22.4334 37.9168 21.8984 37.6952 21.5034 37.3002C21.1084 36.9052 20.8867 36.3702 20.8867 35.8118V25.8335C20.8867 25.2752 21.1084 24.7402 21.5034 24.3452C21.8984 23.9502 22.4334 23.7285 22.9917 23.7285H26.4101C26.9684 23.7285 27.5034 23.9502 27.8984 24.3452C28.2934 24.7402 28.5151 25.2752 28.5151 25.8335Z",
    fill: "#696977"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1137 20.7051V35.8118C19.1137 36.9751 18.172 37.9168 17.0087 37.9168H13.5904C12.427 37.9168 11.4854 36.9751 11.4854 35.8118V20.7051C11.4854 20.1468 11.707 19.6118 12.102 19.2168C12.497 18.8218 13.032 18.6001 13.5904 18.6001H17.0087C18.172 18.6001 19.1137 19.5434 19.1137 20.7051Z",
    fill: "#696977"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9169 20.7051V35.8118C37.9169 36.9751 36.9752 37.9168 35.8119 37.9168H32.3936C31.2302 37.9168 30.2886 36.9751 30.2886 35.8118V20.7051C30.2886 20.1468 30.5102 19.6118 30.9052 19.2168C31.3002 18.8218 31.8352 18.6001 32.3936 18.6001H35.8119C36.9752 18.6001 37.9169 19.5434 37.9169 20.7051Z",
    fill: "#696977"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08373 4.3335C3.53039 3.92016 3.41873 3.13516 3.83373 2.5835C4.24706 2.03183 5.03039 1.92016 5.58373 2.3335L15.5054 9.77516H20.2171C20.6021 9.77516 20.9637 9.95183 21.2004 10.2535L25.0121 15.1052L33.8454 5.88683C34.3221 5.3885 35.1137 5.37183 35.6121 5.85016C36.1104 6.32683 36.1271 7.1185 35.6504 7.61683L25.8204 17.8735C25.5704 18.1352 25.2187 18.2752 24.8571 18.2568C24.4954 18.2402 24.1587 18.0652 23.9354 17.7802L19.6104 12.2752H15.0887C14.8187 12.2752 14.5554 12.1885 14.3387 12.0252L4.08373 4.3335Z",
    fill: "#696977"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSw1);
export default __webpack_public_path__ + "static/media/sw1.4958e00faa4b39ac1292dc449bea7f82.svg";
export { ForwardRef as ReactComponent };